import React from 'react';
import PropTypes from 'prop-types';
import { SuiAutocompleteInput, SuiTextInput, SuiButton } from '@splashthat/sui';
import AddOutline from 'common/icons/AddOutline';
import noop from 'lodash/noop';

const INPUT_LABEL = 'Set your own values';

const autoCompleteValue = ({ value = '', label = '' }) => ({
    value,
    label: typeof label !== 'string' ? '' : label,
});

const DefaultOptionsInput = (props) =>
    !props.hasSuggestions && props.useAdvancedTagsInput ? (
        <SuiTextInput
            value={props.value}
            placeholder={INPUT_LABEL}
            onChange={props.onChange}
            onKeyPress={props.onKeyPress}
            fullWidth
            iconRight={
                props.value && (
                    <SuiButton title={INPUT_LABEL} onClick={props.onClick} icon={AddOutline} variation="icon text" />
                )
            }
        />
    ) : (
        <SuiAutocompleteInput fullWidth {...props} value={autoCompleteValue(props.value)} />
    );

DefaultOptionsInput.propTypes = {
    hasSuggestions: PropTypes.bool.isRequired,
    useAdvancedTagsInput: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
            label: PropTypes.label,
        }),
    ]).isRequired,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    onClick: PropTypes.func,
};

DefaultOptionsInput.defaultProps = {
    onChange: noop,
    onKeyPress: noop,
    onClick: noop,
};

export default DefaultOptionsInput;
